import { useTranslation } from 'react-i18next';
import css from './StockEquipmentItem.module.scss';
import React from 'react';
import { formatEstimatedAvailability } from '../../utils';
import { RouteComponentProps } from '@reach/router';
import { StockEquipment } from '../../../interfaces/customer-api';
interface StockEquipmentDetailsProps extends RouteComponentProps {
    stockEquipment: StockEquipment;
}
export const StockEquipmentDetails: React.FC<StockEquipmentDetailsProps> = (props: StockEquipmentDetailsProps) => {
    const { t } = useTranslation('StockEquipment');
    const { stockEquipment } = props;

    if (!stockEquipment || stockEquipment.id === null) {
        return <p className={css.myEquipmentItem}>{t('No equipment found')}</p>;
    }

    return (
        <>
            <h3>{t('Equipment details')}</h3>
            <dl>
                <dt>{t('Configuration number')}</dt>
                <dd id="configuration-number">{stockEquipment.configurationNumber}</dd>
                <dt>{t('Description')}</dt>
                <dd id="description">{stockEquipment.description}</dd>
                <dt>{t('Model')}</dt>
                <dd id="model">{stockEquipment.model}</dd>
                <dt>{t('Type')}</dt>
                <dd id="type">{stockEquipment.type}</dd>
                <dt>{t('Manufacturing year')}</dt>
                <dd>{stockEquipment.manufacturingYear ? stockEquipment.manufacturingYear.toString() : null}</dd>
                {stockEquipment.engineType && (
                    <>
                        <dt>{t('Engine type')}</dt>
                        <dd id="engine-type">{stockEquipment.engineType}</dd>
                    </>
                )}
                {stockEquipment.mauLocation && (
                    <>
                        <dt>{t('MAU location')}</dt>
                        <dd id="mau-location">{stockEquipment.mauLocation}</dd>
                    </>
                )}
                <dt>{t('Estimated availability')}</dt>
                <dd id="estimated-availability">
                    {formatEstimatedAvailability(
                        stockEquipment.estimatedAvailability,
                        t('Ready'),
                        t('N/A'))}
                </dd>
                <dt>{t('Region')}</dt>
                <dd>{stockEquipment.region?.join(', ')}</dd>
            </dl>
        </>
    );
};
